import BreadcrumbTitle from "components/BreadcrumbTitle"
import PageMetaTags from "components/PageMetaTags"
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import { getCategories, getProducts } from "store/actions"
import OrdersTab from "./ordersTab"
import ProductsTab from "./productsTab"

const ProductsAndSubscriptions = ({ getProducts, getCategories }) => {
  const TABS = {
    ORDERS: 1,
    PRODUCTS: 2,
  }

  const DEFAULT_BREADCRUMB_ITEMS = [
    { title: "Dashboard" },
    {
      title: "Products & Subscriptions",
      type: "tab",
      clickHandler: () => {
        setActiveTab(TABS.ORDERS)
      },
    },
  ]

  const [activeTab, setActiveTab] = useState(TABS.ORDERS)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    getProducts({ o: "name", od: "asc" })
    getCategories({ type: 3 })
  }, [])

  useEffect(() => {
    setBreadcrumbItems([
      ...DEFAULT_BREADCRUMB_ITEMS,
      { title: activeTab === 1 ? "Orders" : "Management" },
    ])
  }, [activeTab])

  const [breadcrumbItems, setBreadcrumbItems] = useState(
    DEFAULT_BREADCRUMB_ITEMS
  )

  const setSubTabBreadcrumb = items => {
    setBreadcrumbItems([...DEFAULT_BREADCRUMB_ITEMS, ...items])
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Products & Subscriptions" />
        <Container fluid>
          <BreadcrumbTitle
            title="Products & Subscriptions"
            breadcrumbItems={breadcrumbItems}
          />
          <Card>
            <CardBody>
              <Nav pills tabs>
                <NavLink
                  className={`${markIfIsActive(TABS.ORDERS)} pt-3`}
                  onClick={() => setActiveTab(TABS.ORDERS)}
                >
                  <span style={{ fontSize: "16px" }}>Orders</span>
                </NavLink>
                <NavLink
                  className={markIfIsActive(TABS.PRODUCTS)}
                  onClick={() => setActiveTab(TABS.PRODUCTS)}
                  style={{ textAlign: "center" }}
                >
                  <span style={{ fontSize: "16px" }}>
                    Products/Subscriptions
                    <br /> Management
                  </span>
                </NavLink>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId={TABS.ORDERS}>
                  <OrdersTab />
                </TabPane>
                <TabPane tabId={TABS.PRODUCTS}>
                  <ProductsTab
                    tabIsActive={activeTab === TABS.PRODUCTS}
                    setSubTabBreadcrumb={setSubTabBreadcrumb}
                  />
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  getProducts: values => dispatch(getProducts(values)),
  getCategories: values => dispatch(getCategories(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductsAndSubscriptions)
